module.exports = __webpack_public_path__ + "img/29_3.17861570.png";